import React from "react";
import "./LowStockDashboard.css";

interface InventoryItem {
  id?: number;
  name?: string;
  category?: string;
  is_low_stock?: boolean;
}

interface LowStockDashboardProps {
  items: InventoryItem[];
  onResolve: (id: number) => void;
}

export default function LowStockDashboard({ items, onResolve }: LowStockDashboardProps) {
  const safeItems = Array.isArray(items) ? items : [];
  const low = safeItems.filter((i) => i.is_low_stock);

  return (
    <div className="ls-card">
      <div className="ls-header">
        🚨 Low Stock Alerts ({low.length})
      </div>

      <div className="ls-body">
        {low.length === 0 ? (
          <div style={{ padding: "20px", textAlign: "center", color: "#888" }}>
            ✅ Good job! No low stock items.
          </div>
        ) : (
          low.map(i => (
            <div key={i.id} className="ls-item">
              <div>
                <span className="ls-name">{i.name}</span>
                <span className="ls-cat">{i.category}</span>
              </div>

              <button
                className="btn-resolve"
                type="button"
                onClick={() => { if (i.id != null) onResolve(Number(i.id)); }}
              >
                Restocked
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
